import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserServicesFactory from '../../user/Services/factory.js'
import {DraftServicesFactory} from '../Services/factory.js'
export class DiscardDraftAdPublisherUseCase extends UseCase {
  #discardDraftService
  #getCurrentUserService

  constructor({config}) {
    super()
    this.#discardDraftService = DraftServicesFactory.discardDraftService({config})
    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({
      config
    })
  }

  static create({config}) {
    return new DiscardDraftAdPublisherUseCase({config})
  }

  @tracer({metric: 'DiscardDraftAdPublisherUseCase#execute'})
  @inlineError
  async execute(draft) {
    const userEntity = await this.#getCurrentUserService.execute()
    const [error, response] = await this.#discardDraftService.execute({...draft, userEntity})

    if (error) return Promise.reject(error)

    return response.toJSON()
  }
}

export const factory = DiscardDraftAdPublisherUseCase.create
